import LibraryBookVersionList from './library-book-version-list';

export default LibraryBookVersionList;
